/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Push_Endpoint_TakenInputs */

const en_error_push_endpoint_taken = /** @type {(inputs: Error_Push_Endpoint_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser receives the notifications of another person: turn them on again.`)
};

/**
* | output |
* | --- |
* | "This browser receives the notifications of another person: turn them on again." |
*
* @param {Error_Push_Endpoint_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_push_endpoint_taken = /** @type {((inputs?: Error_Push_Endpoint_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Push_Endpoint_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_push_endpoint_taken(inputs)
});